<form *ngIf="templateForm" [formGroup]="templateForm" class="content-card">
  <mat-card class="wide-form-card">
    <mat-card-header>
      <mat-card-title>
        <h5>📲 Push Notification Template</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field>
        <input matInput placeholder="Template name" formControlName="name" required>
      </mat-form-field>
      <!--  <mat-form-field>
        <input matInput placeholder="Message subject" formControlName="subject" required>
      </mat-form-field> -->

      <div style="margin-bottom: 30px;">
        <button mat-raised-button color="primary" [disabled]="selectedLanguage === 0" (click)="selectLanguage(0)">German</button>
        <button mat-raised-button color="primary" [disabled]="selectedLanguage === 1" (click)="selectLanguage(1)">English</button>
      </div>

      <div class="template-var-group">
        <button *ngFor="let cmd of commands" mat-raised-button class="template-var-item" color="primary" type="button"
                (click)="insert(cmd.name)">{{cmd.title}}</button>
      </div>


      <br />

      <app-emoji-list (emojiSelected)="onEmojiSelected($event)"></app-emoji-list>

      <br /><br />

      <div style="background-color: lightblue; padding: 20px; border-radius: 15px;">

        <div><i>In the notification area of the device</i></div>
        <br />

        <div><b>Notification Title</b></div>
        <div>
          <small>Displayed in the notification area of the device</small>
        </div>
        <mat-form-field class="full-width" *ngIf="selectedLanguage == 0" >
          <input (focusin)="onFocus($event)" matInput placeholder="Enter notification title" formControlName="notificationTitleDe" required />
        </mat-form-field>
        <mat-form-field class="full-width" *ngIf="selectedLanguage == 1">
          <input (focusin)="onFocus($event)" type="text" matInput placeholder="Enter notification title" formControlName="notificationTitleEn" required />
        </mat-form-field>

        <div><b>Notification Text</b></div>
        <div>
          <small>Displayed in the notification area of the device</small>
        </div>
        <mat-form-field class="full-width" *ngIf="selectedLanguage == 0">
          <input (focusin)="onFocus($event)" matInput placeholder="Enter notification text" formControlName="notificationTextDe" required />
        </mat-form-field>
        <mat-form-field class="full-width" *ngIf="selectedLanguage == 1">
          <input (focusin)="onFocus($event)" type="text" matInput placeholder="Enter notification text" formControlName="notificationTextEn" required />
        </mat-form-field>

      </div>

      <br /><br />

      <div style="background-color: lightgray; padding: 20px; border-radius: 15px;">
        <div><i>In-App after the user taps the notification</i></div>
        <br />

        <div><b>Body Title</b></div>
        <div>
          <small>Displayed in-app when the user taps the notification</small>
        </div>
        <mat-form-field class="full-width" *ngIf="selectedLanguage == 0">
          <input (focusin)="onFocus($event)" matInput placeholder="Enter body title" formControlName="bodyTitleDe" required />
        </mat-form-field>
        <mat-form-field class="full-width" *ngIf="selectedLanguage == 1">
          <input (focusin)="onFocus($event)" type="text" matInput placeholder="Enter body title" formControlName="bodyTitleEn" required />
        </mat-form-field>

        <div><b>Body Text</b></div>
        <div>
          <small>Displayed in-app when the user taps the notification</small>
        </div>
        <textarea (focusin)="onFocus($event)" cols="50" rows="20" *ngIf="selectedLanguage == 0" placeholder="Enter message template" formControlName="bodyTextDe" required></textarea>
        <textarea (focusin)="onFocus($event)" cols="50" rows="20"  *ngIf="selectedLanguage == 1" placeholder="Enter message template" formControlName="bodyTextEn" required></textarea>

        <div class="mb-1 mt-1">
          <span *ngIf="templateForm?.controls['bodyText'+lang]?.value?.length > 500" style="color: red;">
        ~ {{ templateForm?.controls['bodyText'+lang]?.value?.length }}
        </span>
          <span *ngIf="templateForm?.controls['bodyText'+lang]?.value?.length <= 500" style="color: green;">
          ~ {{ templateForm?.controls['bodyText'+lang]?.value?.length }}
        </span>
          <span>
          &nbsp;/&nbsp; 500 &nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        </div>

        <div><b>Action and Action Label</b></div>

        <div>
          <small>If an action is selected, the label of the respective button</small>
        </div>
        <mat-form-field>
          <mat-select placeholder="Action" formControlName="action">
            <mat-option [value]="">(none - no button)</mat-option>
            <mat-option [value]="'ident'">Ident</mat-option>
            <mat-option [value]="'top_up'">Top up</mat-option>
            <mat-option [value]="'refer_friends'">Refer friends</mat-option>
            <mat-option [value]="'convert_physical'">Convert to physical</mat-option>

            <mat-option [value]="'dynaview'">Dynamic view</mat-option>

          </mat-select>
        </mat-form-field>


        <br />

        <div>
          <small>If the selected action needs a parameter, specify here</small>
        </div>
        <mat-form-field class="full-width">
          <input (focusin)="onFocus($event)" type="text" matInput placeholder="Action parameter" formControlName="actionParameter" />
        </mat-form-field>

        <br />

        <div>
          <small>If an action is selected, the label of the respective button</small>
        </div>
        <mat-form-field class="full-width" *ngIf="selectedLanguage == 0">
          <input (focusin)="onFocus($event)" matInput placeholder="Enter action label" formControlName="actionLabelDe" />
        </mat-form-field>
        <mat-form-field class="full-width" *ngIf="selectedLanguage == 1">
          <input (focusin)="onFocus($event)" matInput placeholder="Enter action label" formControlName="actionLabelEn" />
        </mat-form-field>

      </div>

    </mat-card-content>
    <mat-card-actions align="end">
      <a mat-raised-button color="accent" type="button" routerLink="../..">Cancel</a>
      <button mat-raised-button color="primary" type="submit" [disabled]="!templateForm.valid" (click)="onSubmit(templateForm)">Save</button>
    </mat-card-actions>
  </mat-card>
</form>
